import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters } from "./config";

const VendorPaymentList = () => {

  return (
    <Table tableId="vendor_payments" title="Vendor Payment" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-date" idKey="vendor_payment_id" fieldsToSearch={["Vendor", "Amount"]} />
  );
};

export default VendorPaymentList;